import React from 'react';

import { Box, Card } from '@bcp-nextgen-dx-component-factory/design-system';
import { PdfViewerDrawer } from '@components';
import { rem } from '@helpers';

import { useBankDocumentHelper } from './bankDocument.helper';

export const BankDocument: React.FC = () => {
	const {
		resources,
		signedOrUnSigned,
		base64Terms,
		bankTermsDrawerName,
		handleOnClickAcceptTerms,
		termsWereAccepted,
	} = useBankDocumentHelper();

	return (
		<>
			{base64Terms !== undefined && (
				<Box>
					<Card.SignDoc {...signedOrUnSigned} title={resources.descriptionSignDocCard} />
					{base64Terms && (
						<PdfViewerDrawer
							title={resources.titleDoc}
							subtitle={resources.attentionRead}
							base64={base64Terms}
							drawerUniqueName={bankTermsDrawerName}
							handleOnClickAcceptTerms={handleOnClickAcceptTerms}
							wasAccepted={termsWereAccepted}
						/>
					)}
				</Box>
			)}
		</>
	);
};
